import React, { Component } from 'react'
import styled from 'styled-components'
import easing from 'ui/styles/easing'
import theme from 'ui/styles/theme'

const Icon = styled.svg`
  linearGradient stop {
    transition: stop-color 0.3s ${easing.easeOutCubic};
  }

  path {
    transition: stroke 0.3s ${easing.easeOutCubic};
  }
`

export default class IconLargeCircledArrow extends Component {
  static defaultProps = {
    defaultColor: theme.colors.tones.light,
    hoverColor: theme.colors.primary
  }
  
  state = { seed: Math.random() }
  
  render() {
    const {
      defaultColor,
      hoverColor,
      hover
    } = this.props
    
    const { seed } = this.state

    return(
      <Icon
        width="83"
        height="51"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient
            x1="50%"
            y1="5.526%"
            x2="50%"
            y2="100%"
            id={seed}
          >
            <stop
              stopColor={hover ? hoverColor : defaultColor}
              stopOpacity="0"
              offset="0%"
            />
            <stop
              stopColor={hover ? hoverColor : defaultColor}
              offset="100%"
            />
          </linearGradient>
        </defs>
        <g
          transform="rotate(-90 24.5 25.5)"
          fill="none"
          fillRule="evenodd"
        >
            <path
              d="M32.83 57.95l-8.32977132 8.33L16.17 57.95M24.5 66.32606V1"
              stroke={hover ? hoverColor : defaultColor}
            />
            <circle
              stroke={`url(#${seed})`}
              cx="24.5"
              cy="58.5"
              r="24.5"
            />
        </g>
      </Icon>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/generic/IconLargeCircledArrow.js